import React from "react";
import styled from "styled-components";

import Shimmer from "@unibuddy/machop/Experimental/General/components/Shimmer/Shimmer";
import VisuallyHidden from "@unibuddy/machop/Experimental/A11y/components/VisuallyHidden/VisuallyHidden";
import Hidden from "@unibuddy/machop/Experimental/Layout/components/Hidden/Hidden";
import Box from "@unibuddy/machop/Experimental/Layout/components/Box/Box";
import Split from "@unibuddy/machop/Experimental/Layout/components/Split/Split";
import Columns from "@unibuddy/machop/Experimental/Layout/components/Columns/Columns";
import Column from "@unibuddy/machop/Experimental/Layout/components/Column/Column";
import Stack from "@unibuddy/machop/Experimental/Layout/components/Stack/Stack";
import {Container, Body} from "../Layout/Layout";

const Wrapper = styled.div`
    margin: 0 auto;
    width: 100%;
    max-width: 1280px;
`;

const Header = styled.div`
    display: flex;
    align-items: center;
    height: 80px;
    border-bottom: 2px solid var(--solitude);
`;

const Card = styled.div`
    display: flex;
    flex-direction: column;
`;

const CardDetails = styled.div`
    border: 1px solid var(--solitude);
    border-bottom-left-radius: 4px;
    border-bottom-right-radius: 4px;
    border-top: none;
    height: 150px;
`;

const Jumbo = styled.div`
    width: 100%;
    height: 500px;
    background-color: #efefef;
`;

const LoadingLogo = () => (
    <Shimmer style={{width: 100, height: 50}} height={50}>
        <rect x="0" y="0" rx="4" ry="4" width="100%" />
    </Shimmer>
);

const LoadingCard = () => (
    <Card>
        <Shimmer style={{width: "100%", height: 150}} height={150}>
            <rect x="0" y="0" rx="0" ry="0" width="100%" />
        </Shimmer>
        <CardDetails />
    </Card>
);

const LoadingTitle = ({width, height = 20}) => (
    <Shimmer style={{width, height}} height={height} width={width}>
        <rect x="0" y="0" rx="4" ry="4" width={width} height={height} />
    </Shimmer>
);

const LoadingAvatar = () => (
    <Shimmer style={{width: 45, height: 45}} height={45} width={45}>
        <circle cx="22.5" cy="22.5" r="22.5" />
    </Shimmer>
);

const LoadingPage = () => (
    <React.Fragment>
        <VisuallyHidden>Loading...</VisuallyHidden>
        <Container>
            <Body>
                <Header>
                    <Wrapper>
                        <Box padding="medium">
                            <Split verticalAlign="center">
                                <LoadingLogo />
                                <LoadingAvatar />
                            </Split>
                        </Box>
                    </Wrapper>
                </Header>

                <Hidden above="mobile">
                    <Box paddingX="medium" paddingY="large">
                        <Stack space="xlarge">
                            <LoadingTitle width={"85%"} height={40} />
                            <Stack space="medium">
                                <LoadingTitle width={"100%"} />
                                <LoadingTitle width={"80%"} />
                                <LoadingTitle width={"90%"} />
                            </Stack>
                            <LoadingCard />
                        </Stack>
                    </Box>
                </Hidden>

                <Hidden below="tablet">
                    <Stack space="xlarge">
                        <Jumbo />
                        <Wrapper>
                            <Box paddingX="medium">
                                <Stack space="xlarge">
                                    <LoadingTitle width={200} height={40} />
                                    <Columns space="xxlarge">
                                        <Column width="1/3">
                                            <LoadingCard />
                                        </Column>
                                        <Column width="1/3">
                                            <LoadingCard />
                                        </Column>
                                        <Column width="1/3">
                                            <LoadingCard />
                                        </Column>
                                    </Columns>
                                </Stack>
                            </Box>
                        </Wrapper>
                    </Stack>
                </Hidden>
            </Body>
        </Container>
    </React.Fragment>
);

export default LoadingPage;
